import React from 'react';
import './DashboardHeader.css';

function DashboardHeader() {
  return (
    <header className="dashboard-header-main">
      <div className="dashboard-header-content">
        {/* Logo et Ministère */}
        <div className="dashboard-header-left">
          <div className="dashboard-logo-circle">
            <img src="/images/logo-gsu.png" alt="GSU Les Palmiers" />
          </div>
          
          <img src="/images/armoiries-benin.png" alt="Armoiries" className="dashboard-armoiries-img" />
          
          <div className="dashboard-ministry-text">
            <p className="dashboard-ministry-name">MINISTÈRE DES ENSEIGNEMENTS</p>
            <p className="dashboard-ministry-name">SECONDAIRE, TECHNIQUE ET DE LA</p>
            <p className="dashboard-ministry-name">FORMATION PROFESSIONNELLE</p>
            <div className="dashboard-benin-flag"></div>
            <p className="dashboard-ministry-country">RÉPUBLIQUE DU BÉNIN</p>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="dashboard-header-buttons">
          <button 
            className="dashboard-btn-site"
            onClick={() => window.navigateTo && window.navigateTo('home')}
            title="Retourner sur le site public"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            Voir le site
          </button>
          
          <button 
            className="dashboard-btn-connect"
            onClick={() => {
              localStorage.clear();
              window.navigateTo && window.navigateTo('home');
            }}
          >
            Déconnexion
          </button>
        </div>
      </div>
    </header>
  );
}

export default DashboardHeader;
